import React from "react";
import {
  Alert as ChakraAlert,
  AlertTitle,
  AlertDescription,
  AlertProps,
  Flex,
} from "@chakra-ui/react";
import {
  AlertInfoIcon,
  AlertSuccessIcon,
  AlertWarningIcon,
} from "components/Icons";

interface Props extends AlertProps {
  title: string;
  description?: string;
}

const Alert = ({
  status = "info",
  title,
  description,
  ...otherProps
}: Props) => {
  const getAlertIcon = () => {
    switch (status) {
      case "info":
        return <AlertInfoIcon />;
      case "success":
        return <AlertSuccessIcon />;
      case "warning":
        return <AlertWarningIcon />;
      case "error":
        return <AlertWarningIcon />;
    }
  };

  const getAlertBgColor = () => {
    switch (status) {
      case "info":
        return "#EFF6FF";
      case "success":
        return "#EFF6EB";
    }
  };

  return (
    <ChakraAlert
      status={status}
      bgColor={getAlertBgColor()}
      borderRadius="6px"
      p="9px 9px 7px"
      {...otherProps}
    >
      <Flex align="center" h="20px" mr="12px" alignSelf="flex-start">
        {getAlertIcon()}
      </Flex>
      <Flex flexDir="column">
        <AlertTitle
          fontSize="12px"
          lineHeight="20px"
          fontWeight="500"
          color="darkBlue"
        >
          {title}
        </AlertTitle>
        <AlertDescription
          fontSize="12px"
          lineHeight="20px"
          fontWeight="400"
          color="darkBlue"
        >
          {description}
        </AlertDescription>
      </Flex>
    </ChakraAlert>
  );
};

export default Alert;
